/**
 * 
 * Delete Form
 * 
 */

import React, { useState,useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal } from 'reactstrap'
import ButtonSpinner from 'components/ButtonSpinner'
import { Label, Input, FormGroup } from 'reactstrap'
import { useDispatch } from 'react-redux'
function OtpForm(props) {
    const [openDialog, setOpenDialog] = useState(false)
    const [isSubmitting, setSubmitting] = useState(false)
    const dispatch = useDispatch()
    const { children, id,actions } = props
// console.log(id,key,actions,actions)
// const RequestData ={"empId":id.emp_id,"_id":id._id,"refId":id._id,"mode":"family","mobile":id.relationMobile}
    
// if(openDialog){
//     dispatch(actions.sendOtp(RequestData))
// }
    useEffect(() => {
        // onClick={() => dispatch(actions.sendOtp(RequestData))}
        // dispatch(actions.sendOtp(RequestData))
    }, [])

    return (
        <React.Fragment>
            {children && typeof children === 'function' ? children(() => setOpenDialog(!openDialog)) : children || null}


            <Modal
                isOpen={openDialog}
                scrollable={true}
                backdrop={'static'}>
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">OTP</h5>
                    <button type="button" className="btn-close" onClick={() => setOpenDialog(false)} aria-label="Close"></button>

                </div>
                {/* <button
                        type="button"
                        style={{ height: '46px' }}
                        className="btn btn-primary w-5"
                        onClick={() => dispatch(actions.sendOtp(RequestData))}>
                        
                        // onClick={() => dispatch(actions.deleteRecord(id, (val) => setSubmitting(val), () => setOpenDialog(false)))}>
                                                {isSubmitting ? <ButtonSpinner /> : 'Send OTP'}
                    </button> */}
                <div className="modal-body">
                    <FormGroup className='no-margin'>
                        <Label >Enter OTP <span style={{ color: 'red' }}>*</span> </Label>
                        <Input
                            type="text"
                            className="form-control"
                            name="otp"
                            value="otp"
                            // onChange={
                            //     // console.log("data")
                            // }
                            id="otp"
                            placeholder="Enter OTP"
                        />
                    </FormGroup>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        style={{ height: '46px' }}
                        className="btn btn-light"
                        onClick={() => setOpenDialog(false)}>
                        Close
                    </button>
                    <button
                        type="button"
                        style={{ height: '46px' }}
                        className="btn btn-primary"
                        disabled={isSubmitting}
                        onClick={() => dispatch(actions.deleteRecord(id, (val) => setSubmitting(val), () => setOpenDialog(false)))}>
                        {isSubmitting ? <ButtonSpinner /> : 'Verify'}
                    </button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

OtpForm.propTypes = {
    t: PropTypes.any,
    children: PropTypes.func,
    id: PropTypes.string,
    // key: PropTypes.object,
    actions: PropTypes.any,
    dispatch: PropTypes.func
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch
    }
}

export default connect(null, mapDispatchToProps)(OtpForm)